import { Component, ElementRef, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import SwalAlert from 'src/app/utils/swalalert';
import { constants } from 'src/app/constants';
declare var $: any;

@Component({
  selector: 'app-bookings-detail-extends',
  templateUrl: './bookings-detail-extends.component.html',
  styleUrls: ['./bookings-detail-extends.component.css']
})
export class BookingsDetailExtendsComponent {
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  // variables
  book: any = null;
  // tours: any = [];
  // hotels: any = [];
  // movements: any = [];
  // commissions: any = [];

  // typevoucher_boleta: any = null;
  // typevoucher_factura: any = null;
  // typevoucher_income: any = null;
  // typevoucher_expense: any = null;
  // typevoucher_ordernote: any = null;

  constructor(
    public fb: FormBuilder,
    public toolsService: ToolsService,
  ) {

    this.item = this.fb.group({
      booking_id: [null],
      operator_id: [null],
      observations: [null]
    });
  }

  init(booking: any) {
    this.book = booking.book;
    
    // this.typevoucher_boleta = this.toolsService.searchObjByKey(
    //   'BOLETA_ELECTRONICA',
    //   constants.SALE.VOUCHER
    // );
    // this.typevoucher_factura = this.toolsService.searchObjByKey(
    //   'FACTURA_ELECTRONICA',
    //   constants.SALE.VOUCHER
    // );

    // this.typevoucher_income = this.toolsService.searchObjByKey(
    //   'RECIBO_INGRESO',
    //   constants.SALE.VOUCHER
    // );

    // this.typevoucher_expense = this.toolsService.searchObjByKey(
    //   'RECIBO_EGRESO',
    //   constants.SALE.VOUCHER
    // );
    // this.typevoucher_ordernote = this.toolsService.searchObjByKey(
    //   'NOTA_PEDIDO',
    //   constants.SALE.VOUCHER
    // );

  
    // (<any>$('#openExtendsBookingsDetail')).modal('show');
  

    // this.bookingsService.detail(booking.booking_id).subscribe({
    //   next: (data: any) => {
    //     let result = data.data;
    //     this.book = result.book;
    //     this.tours = result.tours;
    //     this.hotels = result.hotels;
    //     this.movements = result.movements;
    //     this.commissions = result.commissions;
    //     console.log(this.book);
    //   }
    // });
  }

  close() {}
}
